import HeaderActions from './HeaderActions';
import './header.styles.css';

const Header = () => {
	return (
		<header className="header relative">
			<img
				alt="Xpress for Business"
				src="/images/svg/logo.svg"
				height={32}
				width={213}
			/>
			<HeaderActions />
		</header>
	);
};

export default Header;
